export interface IQuery { }

export class ApprovalPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.ApprovalPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ScenarioId: string

	constructor (workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.ApprovalPageQueryV1, TCh.Domain.Quest'
	}

}

export class CriteriaPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.CriteriaPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ScenarioId: string

	constructor (workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.CriteriaPageQueryV1, TCh.Domain.Quest'
	}

}

export class ExistingScenarioSettingsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.ExistingScenarioSettingsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	PortfolioScenarioId: string

	constructor (workspaceId: number, portfolioId: string, portfolioScenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.PortfolioScenarioId = portfolioScenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.ExistingScenarioSettingsQueryV1, TCh.Domain.Quest'
	}

}

export class NewScenarioSettingsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.NewScenarioSettingsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	CorporateScenarioId: string

	constructor (workspaceId: number, portfolioId: string, corporateScenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.CorporateScenarioId = corporateScenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.NewScenarioSettingsQueryV1, TCh.Domain.Quest'
	}

}

export class PnlPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.PnlPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ScenarioId: string

	constructor (workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.PnlPageQueryV1, TCh.Domain.Quest'
	}

}

export class PortfolioScenarioPnlQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.PortfolioScenarioPnlQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ScenarioId: string
	ApplyBenefitsConfidenceFactor: boolean
	PnlTemplateId: string
	Denomination: any

	constructor (workspaceId: number, tchProjectId: number, scenarioId: string, applyBenefitsConfidenceFactor: boolean, pnlTemplateId: string, denomination: any)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ScenarioId = scenarioId
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
		this.PnlTemplateId = pnlTemplateId
		this.Denomination = denomination
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.PortfolioScenarioPnlQueryV1, TCh.Domain.Quest'
	}

}

export class PortfolioScenariosPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.PortfolioScenariosPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number

	constructor (workspaceId: number, tchProjectId: number)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.PortfolioScenariosPageQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.ProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ScenarioId: string

	constructor (workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.ProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

export class ResourceConstraintPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.ResourceConstraintPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ScenarioId: string
	ResourceId: string

	constructor (workspaceId: number, tchProjectId: number, scenarioId: string, resourceId: string)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ScenarioId = scenarioId
		this.ResourceId = resourceId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.ResourceConstraintPageQueryV1, TCh.Domain.Quest'
	}

}

export class ReviewPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.ReviewPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ScenarioId: string

	constructor (workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.ReviewPageQueryV1, TCh.Domain.Quest'
	}

}

export class ScenarioProjectPlanPickerQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.ScenarioProjectPlanPickerQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ScenarioId: string
	ProjectId: string

	constructor (workspaceId: number, tchProjectId: number, scenarioId: string, projectId: string)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ScenarioId = scenarioId
		this.ProjectId = projectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.ScenarioProjectPlanPickerQueryV1, TCh.Domain.Quest'
	}

}

export class SchedulingPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.SchedulingPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ScenarioId: string

	constructor (workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.SchedulingPageQueryV1, TCh.Domain.Quest'
	}

}

export class SelectionPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.SelectionPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ScenarioId: string

	constructor (workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.SelectionPageQueryV1, TCh.Domain.Quest'
	}

}

export class SelectorSettingsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.PortfolioScenarios.Queries.SelectorSettingsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	ScenarioId: string

	constructor (workspaceId: number, portfolioId: string, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.PortfolioScenarios.Queries.SelectorSettingsQueryV1, TCh.Domain.Quest'
	}

}

